import { render } from "./select.html?vue&type=template&id=d833114a&scoped=true&ts=true"
import script from "./select.ts?vue&type=script&lang=ts"
export * from "./select.ts?vue&type=script&lang=ts"

import "./select.scss?vue&type=style&index=0&id=d833114a&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d833114a"]])

export default __exports__